export default __webpack_public_path__ + "static/media/bannerContadores.4822323b.jpg";